import type { PropertyGroupResponse } from '@/shared/api';

interface Props {
  groups: PropertyGroupResponse[];
  selectedIds: string[];
  onToggle: (id: string) => void;
}

/** Die Auswahl benennt nur Objektquellen; sichtbare Apartments werden allein vom Server aufgelöst. */
export function CleaningTeamPropertyGroups({ groups, selectedIds, onToggle }: Props) {
  if (groups.length === 0) {
    return <p className="text-ink-faint text-sm">Keine Objekte verfügbar.</p>;
  }

  return (
    <div className="space-y-2">
      {groups.map((group) => (
        <label key={group.id} className="text-ink flex min-h-11 items-center gap-2 text-sm">
          <input
            className="size-4"
            type="checkbox"
            checked={selectedIds.includes(group.id)}
            onChange={() => onToggle(group.id)}
          />
          <span>{group.name}</span>
        </label>
      ))}
    </div>
  );
}
